// Maps Shopee logistics API English descriptions to user-facing Chinese messages.
// Source: ship_order, get_shipping_parameter, and update_address error tables.
// When the same description appears in multiple tables, ship_order takes priority.
// Descriptions containing template placeholders (e.g. {msg}, {ip}) are not listed
// here because the API substitutes real values, making exact matching impossible.

const LOGISTICS_ERROR_MESSAGES: Record<string, string> = {
  // 地址不在收貨範圍
  'Address is not found.':
    '地址不在物流收貨範圍內，請重新設定收貨地址。',
  'Faile to get the nearest whsId.':
    '地址不在物流收貨範圍內，請重新設定收貨地址。',
  'Forder is not exist.':
    '地址不在物流收貨範圍內，請重新設定收貨地址。',
  'Address does not exist.':
    '地址不在物流收貨範圍內，請重新設定收貨地址。',
  'Pickup is not supported.':
    '地址不在物流收貨範圍內，請重新設定收貨地址。',
  'Pickup address is missing.':
    '地址不在物流收貨範圍內，請重新設定收貨地址。',
  'Address is not supported.':
    '地址不在物流收貨範圍內，請重新設定收貨地址。',
  'Address is not supported current operation.':
    '地址不在物流收貨範圍內，請重新設定收貨地址。',
  'Pickup address is not supported.':
    '地址不在物流收貨範圍內，請重新設定收貨地址。',
  'Some addresses are no longer supported per new regulation, please update to avoid wrong fulfilment':
    '地址不在物流收貨範圍內，請重新設定收貨地址。',
  'No supported pickup address':
    '地址不在物流收貨範圍內，請重新設定收貨地址。',

  // 地址無法支援收貨
  'Buyer address is not found.':
    '該地址無法支援收貨，請修改地址重試一次。',
  'Address is invalid. Please check the address.':
    '該地址無法支援收貨，請修改地址重試一次。',
  'Sender address is invalid. Please check the sender address.':
    '該地址無法支援收貨，請修改地址重試一次。',
  'Pickup address not valid. Please add/tag a new pickup_address in Seller Center to continue shipping':
    '該地址無法支援收貨，請修改地址重試一次。',

  // 請填寫收貨地址
  'Pickup address is required.':
    '請填寫收貨地址後再試一次。',
  'Fail to set seller address.':
    '請填寫收貨地址後再試一次。',
  'This order has no seller address.':
    '請填寫收貨地址後再試一次。',

  // 地址其他
  'Zipcode is not found.':
    '找不到郵遞區號，請再試一次。',
  'Parameter address_id and pickup_time_id are required.':
    '請填寫取件地址並選擇收貨時間後再試一次。',

  // 取件時間
  'Pickup time is not invalid. Please check the pickup time.':
    '無效的取件時間，請確認後重新選擇。',
  'Pickup time is invalid. Please check the pick up time.':
    '取件時間錯誤，請填寫正確資訊。',
  'Invalid pickup time id. Please check the pick up time id.':
    '請選擇取件時間後再試一次。',
  'Invalid pickup time. Please select another pickup time.':
    '請選擇取件時間後再試一次。',
  'Selected pickup timeslot is unavailable. Please reselect.':
    '請選擇取件時間後再試一次。',
  'No available time slot':
    '目前物流暫無可支援的收貨時段，請稍後再試。',
  'No supported drop-off branch':
    '目前無可支援的可寄件門市，請重新選擇。',

  // 電話
  'Phone number is invalid. Please check the phone number.':
    '電話號碼錯誤，請填寫正確資訊。',

  // 寄件人
  'Parameter sender_real_name or tracking_number is required.':
    '請填寫寄件人姓名後再試一次。',
  'Parameter sender_real_name can not be null.':
    '請填寫寄件人姓名後再試一次。',
  'Parameter sender_real_name can not be longer than 64.':
    '寄件人姓名長度不可超過64字，請填寫寄件人姓名後再試一次。',

  // 訂單狀態
  'Order is expired.':
    '訂單已過期，無法進行此操作。',
  'Operation is not allow with current order status.':
    '目前訂單狀態不允許此操作。',
  'The order is not ready to ship.':
    '該訂單尚不可出貨，請稍後再試。',
  'Order is already in finalized status.':
    '訂單已完成。',
  "This package has already been arranged shipment and you can't call this API again.":
    '包裹已出貨，不需重複操作。',
  "This order is matched order with booking, don't need arrange shipment through seller side.":
    '此訂單已由系統完成出貨，請勿重複操作。',
  'Order is not found.':
    '請選擇訂單後，請再試一次。',
  'Relative order is not found.':
    '找不到訂單資訊，若有疑問請聯繫客服。',
  'The package is not exist.':
    '找不到訂單資訊，若有疑問請聯繫客服。',
  'Please select just one way to ship order: pickup or dropoff or non_integrated.':
    '請選擇唯一出貨方式。',
  'The order has been cancelled.':
    '該訂單已被取消，請重新再試。',
  'The order is being allocated, please wait until the allocate is completed.':
    '請等待訂單正在處理中，請稍後再試。',

  // 取消
  'Cancel is not allowed.':
    '此訂單無法取消。',
  'Cancel operation is not supported for current logistics txn.':
    '此訂單無法取消。',

  // 品項 / 庫存
  'There are contraband goods in the order.':
    '訂單含有禁運品項。',
  'Can not find the item.':
    '查無此商品，請確認後再試。',
  'Failed to assign a warehouse with sufficient stock':
    '庫存不足，無法支援出貨。',

  // 單號
  'Consignment number is duplicated.':
    '寄件單號已重複，請確認後重新輸入。',
  'Consignment number is duplicate.':
    '寄件單號已重複，請確認後重新輸入。',
  'Return tracking number is not found.':
    '找不到退貨單號，請再試一次。',
  'History is not found.':
    '找不到歷史紀錄。',
  'Trace number is required.':
    '請填寫追蹤單號。',

  // 系統忙碌
  'Failed to get lock.':
    '系統忙碌中，請稍後再試。',
  'Fail to get the lock.':
    '系統忙碌，請稍後再試。',
  'Currently, update is not allow.':
    '系統忙碌，請稍後再試。',
  'Currently, logistics is not supported to update.':
    '系統忙碌中，請稍後再試。',

  // 超商門市
  'Store status is unavailable,pending buyer update.':
    '買家取件超商關閉，等待買家重新選擇超商。',

  // 系統異常（請於5分鐘後再試）
  'System error. Please try again later.':
    '系統異常，請於5分鐘之後再試一次。',
  'Something wrong. Please try later.':
    '系統異常，請於5分鐘之後再試一次。',
  'System error, please try again later.':
    '系統異常，請於5分鐘之後再試一次。',
  'Rescheduling dependency error':
    '系統異常，請於5分鐘之後再試一次。',
  'Remove OFG from GROUP error, please try again.':
    '系統錯誤，請稍後再試。',

  // 系統流程
  'Business process failed.':
    '系統流程執行失敗，請稍後再試。',
  'Business validation failed.':
    '資料驗證失敗，請確認輸入內容。',

  // 請求超限
  'The batch request reach limit 50.':
    '請求數量已超上限(50筆)，若此訂單目前的狀態無法更新物流，請確認訂單狀態後再試。',
  'Can not update order logistics in current status.':
    '請求數量已超上限(50筆)，若此訂單目前的狀態無法更新物流，請確認訂單狀態後再試。',
  'Parcel count should not exceed limit.':
    '請求數量已超上限(50筆)，若此訂單目前的狀態無法更新物流，請確認訂單狀態後再試。',
  'Order status not support update logistics.':
    '請求數量已超上限(50筆)，若此訂單目前的狀態無法更新物流，請確認訂單狀態後再試。',

  // 貨到付款
  'Cod pickup is not supported with the seller address.':
    '賣家地址不支援貨到付款。',

  // 物流參數錯誤（catch-all for error_param group）
  'The address is invalid. Please check the address.':
    '物流資訊有誤，請確認收件地址、物流方式或訂單是否正確，如仍有問題請聯繫客服。',
  'Please wait for buyer to reselect the delivery convenience store.':
    '物流資訊有誤，請確認收件地址、物流方式或訂單是否正確，如仍有問題請聯繫客服。',
  'Logistic status is not supported.':
    '物流資訊有誤，請確認收件地址、物流方式或訂單是否正確，如仍有問題請聯繫客服。',
  'Deliver address not support COD.':
    '物流資訊有誤，請確認收件地址、物流方式或訂單是否正確，如仍有問題請聯繫客服。',
  'Delivery address do not support COD.':
    '物流資訊有誤，請確認收件地址、物流方式或訂單是否正確，如仍有問題請聯繫客服。',
  'This address do not support delivery.':
    '物流資訊有誤，請確認收件地址、物流方式或訂單是否正確，如仍有問題請聯繫客服。',
  'Delivery address is not exist.':
    '物流資訊有誤，請確認收件地址、物流方式或訂單是否正確，如仍有問題請聯繫客服。',
  'Buyer address is not exist.':
    '物流資訊有誤，請確認收件地址、物流方式或訂單是否正確，如仍有問題請聯繫客服。',
  'Delivery store is not exist.':
    '物流資訊有誤，請確認收件地址、物流方式或訂單是否正確，如仍有問題請聯繫客服。',
  'Delivery address is not completed.':
    '物流資訊有誤，請確認收件地址、物流方式或訂單是否正確，如仍有問題請聯繫客服。',
  'This order is not allowed to cancel.':
    '物流資訊有誤，請確認收件地址、物流方式或訂單是否正確，如仍有問題請聯繫客服。',
  'Order is not exist.':
    '物流資訊有誤，請確認收件地址、物流方式或訂單是否正確，如仍有問題請聯繫客服。',
  'This order can not be splited.':
    '物流資訊有誤，請確認收件地址、物流方式或訂單是否正確，如仍有問題請聯繫客服。',
  'Order is not splittable.':
    '物流資訊有誤，請確認收件地址、物流方式或訂單是否正確，如仍有問題請聯繫客服。',
  'Parcels of this order can not be combined.':
    '物流資訊有誤，請確認收件地址、物流方式或訂單是否正確，如仍有問題請聯繫客服。',
  'Order/Forder can not update.':
    '物流資訊有誤，請確認收件地址、物流方式或訂單是否正確，如仍有問題請聯繫客服。',
  'Order has been shipped.':
    '物流資訊有誤，請確認收件地址、物流方式或訂單是否正確，如仍有問題請聯繫客服。',
  'Order has been splitted.':
    '物流資訊有誤，請確認收件地址、物流方式或訂單是否正確，如仍有問題請聯繫客服。',
  'The order status is not ready to ship.':
    '物流資訊有誤，請確認收件地址、物流方式或訂單是否正確，如仍有問題請聯繫客服。',
  'The buyer address is invalid. Please check the buyer address.':
    '物流資訊有誤，請確認收件地址、物流方式或訂單是否正確，如仍有問題請聯繫客服。',
  'Shop not found.':
    '物流資訊有誤，請確認收件地址、物流方式或訂單是否正確，如仍有問題請聯繫客服。',
  'Only support local warehouse, this shop do not support local warehouse.':
    '物流資訊有誤，請確認收件地址、物流方式或訂單是否正確，如仍有問題請聯繫客服。',
  'This shop do not support split parcels.':
    '物流資訊有誤，請確認收件地址、物流方式或訂單是否正確，如仍有問題請聯繫客服。',
  'Size setting error.':
    '物流資訊有誤，請確認收件地址、物流方式或訂單是否正確，如仍有問題請聯繫客服。',
  'Invalid logistics channel. Please check the logictics channel.':
    '物流資訊有誤，請確認收件地址、物流方式或訂單是否正確，如仍有問題請聯繫客服。',
  'Can not update order logistics.':
    '物流資訊有誤，請確認收件地址、物流方式或訂單是否正確，如仍有問題請聯繫客服。',
  'Warehouse address not supported.':
    '物流資訊有誤，請確認收件地址、物流方式或訂單是否正確，如仍有問題請聯繫客服。',
  'Package exceeds weight limit. Please adjust or contact Shopee CS for more info.':
    '物流資訊有誤，請確認收件地址、物流方式或訂單是否正確，如仍有問題請聯繫客服。',
  'Pickup address do not support COD.':
    '物流資訊有誤，請確認收件地址、物流方式或訂單是否正確，如仍有問題請聯繫客服。',
  'This address do not support pickup.':
    '物流資訊有誤，請確認收件地址、物流方式或訂單是否正確，如仍有問題請聯繫客服。',
  "Buyer's delivery address is not serviceable. Please contact customer service.":
    '物流資訊有誤，請確認收件地址、物流方式或訂單是否正確，如仍有問題請聯繫客服。',
  'Seller address is not completed.':
    '物流資訊有誤，請確認收件地址、物流方式或訂單是否正確，如仍有問題請聯繫客服。',
  'Channel does not support dropoff. Please select the pickup option and try again.':
    '物流資訊有誤，請確認收件地址、物流方式或訂單是否正確，如仍有問題請聯繫客服。',
  'Please input a unique tracking number.':
    '物流資訊有誤，請確認收件地址、物流方式或訂單是否正確，如仍有問題請聯繫客服。',
  'Seller Info Error. Please check and input your invoice info.':
    '物流資訊有誤，請確認收件地址、物流方式或訂單是否正確，如仍有問題請聯繫客服。',
  'Tracking Number Error. Please input a valid tracking number.':
    '物流資訊有誤，請確認收件地址、物流方式或訂單是否正確，如仍有問題請聯繫客服。',
  'Tracking Number Format Error. Please input a valid tracking number.':
    '物流資訊有誤，請確認收件地址、物流方式或訂單是否正確，如仍有問題請聯繫客服。',
  "Please input a valid seller's name.":
    '物流資訊有誤，請確認收件地址、物流方式或訂單是否正確，如仍有問題請聯繫客服。',
  'Pickup address is not serviceable. Please select another address.':
    '物流資訊有誤，請確認收件地址、物流方式或訂單是否正確，如仍有問題請聯繫客服。',
  'Seller Info Error. Please check and input your tax number.':
    '物流資訊有誤，請確認收件地址、物流方式或訂單是否正確，如仍有問題請聯繫客服。',
  'Seller address is not exist. Please try other address.':
    '物流資訊有誤，請確認收件地址、物流方式或訂單是否正確，如仍有問題請聯繫客服。',
  'Sender address is not exist.':
    '物流資訊有誤，請確認收件地址、物流方式或訂單是否正確，如仍有問題請聯繫客服。',
  'Seller Address Error. Please input the geo-location of your address.':
    '物流資訊有誤，請確認收件地址、物流方式或訂單是否正確，如仍有問題請聯繫客服。',
  'Channel does not support pickup. Please select the dropoff option and try again.':
    '物流資訊有誤，請確認收件地址、物流方式或訂單是否正確，如仍有問題請聯繫客服。',
  'Seller address is invalid. Please check your address.':
    '物流資訊有誤，請確認收件地址、物流方式或訂單是否正確，如仍有問題請聯繫客服。',
  'Order list length exceeds limit.':
    '物流資訊有誤，請確認收件地址、物流方式或訂單是否正確，如仍有問題請聯繫客服。',

  // 更新地址
  'Cannot set inbound pickup address for this address.':
    '地址輸入錯誤或無法使用，請確認後重新輸入。',
  'Inbound pickup address invalid state & city, state&city must be the same as kyc.billing_address state&city or fbs_branch.billing_address state&city.':
    '地址輸入錯誤或無法使用，請確認後重新輸入。',
  'Inbound pickup address cannot be the same as Shopee warehouse address.':
    '地址輸入錯誤或無法使用，請確認後重新輸入。',
  'The param is invalid. not allow to edit address region.':
    '資訊更新失敗，請再試一次或聯繫蝦皮到店確認。',

  // 賣場 / 權限
  'shopid is invalid':
    '賣場ID錯誤，請聯繫客服協助處理。',
  "Sorry you don't have the permission, detail: {msg}.":
    '沒有權限執行此操作，請聯繫客服協助處理。',

  // 系統異常（聯繫客服）
  'Fail to find the fulfillment channel of this order.':
    '系統異常，請聯繫客服協助處理。',
  'You have not set warehouse.':
    '系統異常，請聯繫客服協助處理。',
  'Buyer addressid is invalid. Please check the buyer addressid.':
    '系統異常，請聯繫客服協助處理。',
  'Connection to external system is failed.':
    '系統異常，請聯繫客服協助處理。',
  'Fail to get consignment number.':
    '系統異常，請聯繫客服協助處理。',
  'Consignment number is not allow to update.':
    '系統異常，請聯繫客服協助處理。',
  'Fail to call core server.':
    '系統異常，請聯繫客服協助處理。',
  'Receive invalid decimal.':
    '系統異常，請聯繫客服協助處理。',
  'Content format from external system is invalid. Please check the format.':
    '系統異常，請聯繫客服協助處理。',
  'Channel id is invalid. Please check the channel.':
    '系統異常，請聯繫客服協助處理。',
  'Logistic info is invalid. Please check the logistic info.':
    '系統異常，請聯繫客服協助處理。',
  'Logistics record is not found.':
    '系統異常，請聯繫客服協助處理。',
  'Message type is invalid. Please check the message type.':
    '系統異常，請聯繫客服協助處理。',
  'Operation is not supported.':
    '系統異常，請聯繫客服協助處理。',
  'Cdt settings is not found.':
    '系統異常，請聯繫客服協助處理。',
  'Not found.':
    '系統異常，請聯繫客服協助處理。',
  'Operation failed.':
    '系統異常，請聯繫客服協助處理。',
  'Order context is invalid. Please check the order context.':
    '系統異常，請聯繫客服協助處理。',
  'Fail to set actual shipping fee.':
    '系統異常，請聯繫客服協助處理。',
  'Store is not found.':
    '系統異常，請聯繫客服協助處理。',
  'Failed to call external system.':
    '系統異常，請聯繫客服協助處理。',
  'Timeout to call external system.':
    '系統異常，請聯繫客服協助處理。',
  'Token is invalid. Please check the token.':
    '系統異常，請聯繫客服協助處理。',
  'Unknown exception, exception details is: {details}.':
    '系統異常，請聯繫客服協助處理。',
  'Fail to update.':
    '系統異常，請聯繫客服協助處理。',
  'Feature is not supported.':
    '系統異常，請聯繫客服協助處理。',
  'Size is invalid. Please check the':
    '系統異常，請聯繫客服協助處理。',
  'Channel is not allow to disable due to there is item in the bundle.':
    '系統異常，請聯繫客服協助處理。',
  'Pending invoice data, can not arrange shipment.':
    '系統異常，請聯繫客服協助處理。',
  'Max dimension or weight is limited.':
    '系統異常，請聯繫客服協助處理。',
  'Cdt settings is missing.':
    '系統異常，請聯繫客服協助處理。',
  'Buyer store is missing.':
    '系統異常，請聯繫客服協助處理。',
  'Can Not Found Proportion.':
    '系統異常，請聯繫客服協助處理。',
  "This order hasn't passed prescription check":
    '系統異常，請聯繫客服協助處理。',
  'The order amount is over limit.':
    '系統異常，請聯繫客服協助處理。',
  'Permission is deny for pickup.':
    '系統異常，請聯繫客服協助處理。',
  'The price is invalid. Please check the price.':
    '系統異常，請聯繫客服協助處理。',
  'The quantity is invalid. Please check the quantity.':
    '系統異常，請聯繫客服協助處理。',
  'Receiver storeid is not found.':
    '系統異常，請聯繫客服協助處理。',
  'Parameter tracking_number can not be longer than 64.':
    '系統異常，請聯繫客服協助處理。',
  'Parameter branch_id is required.':
    '系統異常，請聯繫客服協助處理。',
  'Please request with package_number for this split order.':
    '系統異常，請聯繫客服協助處理。',
  'Parameter tracking_number can not be null.':
    '系統異常，請聯繫客服協助處理。',
  "Please don't request with package_number for this unsplit order.":
    '系統異常，請聯繫客服協助處理。',
  'You can not ship warehouse order.':
    '系統異常，請聯繫客服協助處理。',
  'This order does not support ship with dropoff.':
    '系統異常，請聯繫客服協助處理。',
  'This order does not support ship with non_integrated.':
    '系統異常，請聯繫客服協助處理。',
  'This order does not support ship with pickup.':
    '系統異常，請聯繫客服協助處理。',
  'Shop is not found.':
    '系統異常，請聯繫客服協助處理。',
  'Wms is not supported for the shop.':
    '系統異常，請聯繫客服協助處理。',
  'Shop id is invalid. Please check your shop.':
    '系統異常，請聯繫客服協助處理。',
  'Fail to calculate estimated shipping fee.':
    '系統異常，請聯繫客服協助處理。',
  'Buyer name is prohibited.':
    '系統異常，請聯繫客服協助處理。',
  'parse data failed':
    '系統異常，請聯繫客服協助處理。',
  'data not exist':
    '系統異常，請聯繫客服協助處理。',
  'Invalid access_token.':
    '系統異常，請聯繫客服協助處理。',
  'No permission to current api.':
    '系統異常，請聯繫客服協助處理。',
  'Wrong sign.':
    '系統異常，請聯繫客服協助處理。',
  'Inner http call failed':
    '系統異常，請聯繫客服協助處理。',
  'Currently, operation is not supported with current logistics record status.':
    '系統異常，請聯繫客服協助處理。',
  'Operation is not supported with current logistics record status.':
    '系統異常，請聯繫客服協助處理。',
  "Buyer hasn't completed pre-authorization yet.":
    '系統異常，請聯繫客服協助處理。',
  'No valid shipping parameters. Please contact support':
    '系統異常，請聯繫客服協助處理。',
  'Thaipost do not support this country.':
    '系統異常，請聯繫客服協助處理。',

  // 其他 
  "ValueError('failed to get tn')":
    '暫時無法取得寄件編號，請回上傳工作區點選重試按鈕。',
};

/**
 * Returns the Chinese user-facing message for a Shopee logistics API error description.
 * Falls back to the original string if no mapping is found.
 */
export function translateLogisticsError(msg: string | null | undefined): string {
  if (!msg) return '';
  return LOGISTICS_ERROR_MESSAGES[msg.trim()] ?? msg;
}

